import { pendingTask, begin, end } from '../constants/pendingTask';
import * as actions from './actionTypes';
import * as actionHelpers from '../scripts/actionHelpers';
import { fetchFromAuthApi as fetch } from './fetchFromApi';

/**
 * Fetch analytics entitlement data from Auth API
 * Dispatches LOAD_ANALYTICS_ENTITLEMENT_SUCCESS or LOAD_ANALYTICS_ENTITLEMENT_FAILURE
 */
export const fetchAnalyticsEntitlement = () => {
  return (dispatch) => {
    dispatch({ type: actions.TASK_BEGIN, [pendingTask]: begin });

    return fetch(`/analyticsEntitlement/getAnalyticsEntitlement`)
      .then((response) => response.json())
      .then((data) => {
        if (actionHelpers.isErrorResponse(data)) {
          return actionHelpers.dispatchErrorAndEndTask(
            dispatch,
            actions.LOAD_ANALYTICS_ENTITLEMENT_FAILURE,
            data
          );
        }

        dispatch({
          type: actions.LOAD_ANALYTICS_ENTITLEMENT_SUCCESS,
          analyticsEntitlementData: data,
          [pendingTask]: end,
        });

        return data;
      })
      .catch((error) => {
        return actionHelpers.dispatchErrorAndEndTask(
          dispatch,
          actions.LOAD_ANALYTICS_ENTITLEMENT_FAILURE,
          null,
          error
        );
      });
  };
};

/**
 * Insert or update analytics entitlement data from Auth API
 * Dispatches MANAGE_ANALYTICS_ENTITLEMENT_SUCCESS or MANAGE_ANALYTICS_ENTITLEMENT_FAILURE
 */
export function manageAnalyticsEntitlement(request) {
  return function (dispatch) {
    dispatch({ type: actions.TASK_BEGIN, [pendingTask]: begin });

    return fetch(`/analyticsEntitlement/manageAnalyticsEntitlement`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(request),
    })
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (actionHelpers.isErrorResponse(result)) {
          return actionHelpers.dispatchErrorAndEndTask(
            dispatch,
            actions.MANAGE_ANALYTICS_ENTITLEMENT_FAILURE,
            result
          );
        }

        dispatch({
          type: actions.MANAGE_ANALYTICS_ENTITLEMENT_SUCCESS,
          result,
          [pendingTask]: end,
        });
      })
      .catch((error) => {
        actionHelpers.dispatchErrorAndEndTask(
          dispatch,
          actions.MANAGE_ANALYTICS_ENTITLEMENT_FAILURE,
          null,
          error
        );
      });
  };
}
